export const heroImageWidths = [
  200, 300, 400, 500, 600, 700, 960, 1440, 1920, 2400
];
